"use strict";

exports.__esModule = true;
var _CommentLoader = require("./CommentLoader");
Object.keys(_CommentLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommentLoader[key]) return;
  exports[key] = _CommentLoader[key];
});